import types from "./types";

const user = JSON.parse(localStorage.getItem("user"));
const token = localStorage.getItem("_tk_");
const emplyInitialState = {
    loggedIn: false,
    user: null,
    error: null
};
const initialState = token ? (user ? {loggedIn: true, user, error: null} : emplyInitialState) : emplyInitialState;

if (!token) {
    localStorage.removeItem("user");
}

export default (state = initialState, action) => {
    switch (action.type) {
        case types.LOGIN: {
            let data = {...state, loggedIn: false}
            if (action.payload && action.payload.user) {
                data.user = {
                    name: action.payload.user
                }
            }
            return data;
        }

        case types.LOGIN_SUCCESS: {
            const user = action.payload;
            localStorage.setItem("user", JSON.stringify(user));
            return {
                ...state,
                loggedIn: true,
                user
            };
        }

        case types.LOGIN_FAIL: {
            return {
                ...state,
                loggedIn: false,
                user: null,
                error: action.payload
            };
        }

        case types.LOGOUT: {
            localStorage.removeItem("user");
            localStorage.removeItem("_tk_");
            localStorage.removeItem("_rf_");
            return {
                ...state,
                loggedIn: false,
                user: null,
                error: null
            };
        }

        case types.EXPIRED_TOKEN: {
            localStorage.removeItem("user");
            localStorage.removeItem("_tk_");
            return {
                ...state,
                loggedIn: false,
                user: null,
                error: null
            };
        }

        case types.NEW_TOKEN: {
            const {token, refresh_token} = action.payload;
            localStorage.setItem("_tk_", token);
            localStorage.setItem("_rf_", refresh_token);
            return state;
        }

        default: {
            return state;
        }
    }
};
